"use client";

import dynamic from "next/dynamic";

import { EnumModalName } from "@/enums/modal-state";
import { useModalStore } from "@/store/modal.store";
import Modal from "@/ui/Common/Modal";
import { CountrySearch } from "@/ui/Modals/CountrySearch";
import { Gallery } from "@/ui/Modals/Gallery";
import { SubscribeModal } from "@/ui/Modals/SubscribeModal";
import PasswordResetForm from "../../Forms/RealtorProfileForm/PasswordResetForm";

const ModalShareLink = dynamic(() => import("@/widgets/Modal/ShareLink"), {
  ssr: false,
});

const ModalAuthRequired = dynamic(
  () => import("@/widgets/Modal/AuthRequired"),
  { ssr: false },
);

const ModalCallBack = dynamic(() => import("@/widgets/Modal/CallBack"), {
  ssr: false,
});

const ModalMessengerNotInstalled = dynamic(
  () => import("@/widgets/Modal/MessengerNotInstalled"),
  { ssr: false },
);

export const ModalLayout = () => {
  const { modal, closeModal } = useModalStore();
  const handleCloseModal = () => {
    closeModal();
  };
  return (
    <>
      {/* UNUSED */}
      {modal.modalName === EnumModalName.countrySearch && (
        <Modal onClose={handleCloseModal}>
          <CountrySearch />
        </Modal>
      )}
      {/* UNUSED */}
      {modal.modalName === EnumModalName.subscribe && (
        <Modal onClose={handleCloseModal}>
          <SubscribeModal />
        </Modal>
      )}

      {modal.modalName === EnumModalName.gallery && (
        <Modal
          isFullScreen
          closeColor={"white"}
          onClose={handleCloseModal}
        >
          <Gallery />
        </Modal>
      )}

      {modal.modalName === EnumModalName.authRequired && (
        <Modal onClose={handleCloseModal}>
          <ModalAuthRequired />
        </Modal>
      )}

      {modal.modalName === EnumModalName.shareLink && (
        <Modal onClose={handleCloseModal}>
          <ModalShareLink {...(modal.data ?? {})} />
        </Modal>
      )}

      {modal.modalName === EnumModalName.callBack && (
        <Modal onClose={handleCloseModal}>
          <ModalCallBack />
        </Modal>
      )}

      {modal.modalName === EnumModalName.messengerNotInstalled && (
        <Modal onClose={handleCloseModal}>
          <ModalMessengerNotInstalled />
        </Modal>
      )}

      {modal.modalName === EnumModalName.resetPassword && (
        <Modal onClose={handleCloseModal}>
          <PasswordResetForm />
        </Modal>
      )}
    </>
  );
};
